module.exports = __webpack_public_path__ + "static/img/pc.7170673.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en/小学/pc.svg
// module id = N+ru
// module chunks = 16